import React from 'react';
import { useNavigate } from 'react-router-dom';
import ThemeToggle from '../ThemeToggle';

const Forbidden = () => {
  const navigate = useNavigate();
  const token = localStorage.getItem('token');

  const goBack = () => {
    if (token) {
      navigate('/home');
    } else {
      navigate('/login');
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-6 text-center bg-background-light dark:bg-background-dark transition-colors">
      <div className="absolute top-5 right-5"><ThemeToggle /></div>
      <div className="max-w-lg w-full">
        <h1 className="text-8xl font-black bg-gradient-to-b from-primary-dark to-accent-yellow bg-clip-text text-transparent drop-shadow-sm mb-6 select-none">403</h1>
        <h2 className="text-2xl font-semibold text-black dark:text-white mb-4">ไม่มีสิทธิ์เข้าถึงหน้านี้</h2>
        <p className="text-gray-600 dark:text-gray-300 mb-8 leading-relaxed">ดูเหมือนว่าบัญชีของคุณไม่มีสิทธิ์สำหรับเนื้อหานี้ หรือการเข้าสู่ระบบหมดอายุ โปรดลองกลับไปยังหน้าหลักหรือเข้าสู่ระบบใหม่</p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button onClick={goBack} className="gradient-btn px-6 py-3 rounded-lg text-white font-medium shadow-light dark:shadow-lightdark hover:shadow-card dark:hover:shadow-carddark transition">
            {token ? 'กลับไปหน้า Home' : 'ไปหน้าเข้าสู่ระบบ'}
          </button>
          {token && (
            <button
              onClick={() => { localStorage.removeItem('token'); localStorage.removeItem('username'); navigate('/login'); }}
              className="px-6 py-3 rounded-lg bg-white dark:bg-surface-dark border border-borderc-light dark:border-borderc-dark text-black dark:text-white font-medium hover:bg-neutral-50 dark:hover:bg-[#333333] transition"
            >ออกจากระบบ</button>
          )}
        </div>
      </div>
    </div>
  );
};

export default Forbidden;
